import React from 'react';
import { Notification } from 'services';
import DonutChart from 'shared/components/Graph/DonutChart';
import { fluid } from 'components/UserDashboardV2/utils/responsive';
import DiscountIcon from '../dashboardV3/discount-badge.svg';
import { formatFeeDate } from './feeUtils';

const FeePaymentSidebar = ({
    totalPaid,
    paymentModeSplit,
    chartSegments,
    splitTotal,
    defaultSplitColors,
    currentFee,
    discountsList,
}) => {
    return (
        <div
            className="staff-profile-info-scroll"
            style={{
                flex: `0 0 ${fluid(598)}`,
                width: fluid(598),
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                gap: fluid(24),
                overflowY: "auto",
                overflowX: "hidden",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
            }}
        >
            {/* Card 1: Payment mode split */}
            <div style={{ width: "100%", backgroundColor: "#FFFFFF", borderRadius: fluid(24), padding: fluid(24), boxSizing: "border-box", display: "flex", flexDirection: "column", gap: fluid(20) }}>
                <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(20), fontWeight: 500, color: "#191919" }}>
                    Payment mode split
                </span>
                <div style={{ display: "flex", alignItems: "center", gap: fluid(32) }}>
                    <div style={{ width: fluid(129), maxWidth: fluid(129), flexShrink: 0 }}>
                        <DonutChart
                            fluid
                            size={129}
                            strokeWidth={14}
                            gapDegrees={splitTotal > 0 ? 8 : 0}
                            segments={chartSegments}
                        >
                            <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(18), fontWeight: 700, color: "#191919" }}>
                                {totalPaid >= 1000 ? `₹${Math.round(totalPaid / 1000)}k` : `₹${totalPaid}`}
                            </span>
                        </DonutChart>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: fluid(12), flex: 1 }}>
                        {paymentModeSplit.map((item, idx) => (
                            <div key={idx} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: fluid(8) }}>
                                    <div style={{ width: fluid(14), height: fluid(14), backgroundColor: item.color || defaultSplitColors[idx % defaultSplitColors.length], borderRadius: fluid(4) }} />
                                    <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(15), color: "#666666" }}>{item.mode}</span>
                                </div>
                                <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(15), color: "#191919", fontWeight: 500 }}>{item.percent}%</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Card 2: Reminders sent */}
            <div style={{ width: "100%", backgroundColor: "#FFFFFF", borderRadius: fluid(24), padding: fluid(24), boxSizing: "border-box", display: "flex", flexDirection: "column", gap: fluid(16) }}>
                <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(20), fontWeight: 500, color: "#191919" }}>
                    Reminders sent
                </span>
                <div style={{ display: "flex", flexDirection: "column", gap: fluid(12) }}>
                    {(Array.isArray(currentFee.remindersSent) && currentFee.remindersSent.length > 0
                        ? currentFee.remindersSent
                        : (Array.isArray(currentFee.reminders) && currentFee.reminders.length > 0)
                            ? currentFee.reminders
                            : [
                                { date: "2 Sep 2026", type: "SMS", status: "Delivered" },
                                { date: "28 Aug 2026", type: "Email", status: "Opened" },
                                { date: "22 Aug 2026", type: "Push", status: "Read" },
                            ]
                    ).map((rem, rIdx) => (
                        <div key={rIdx} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(15), color: "#666666" }}>
                                {rem.date ? formatFeeDate(rem.date) : ""}{rem.type ? ` · ${rem.type}` : ""}
                            </span>
                            <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(15), color: "#191919", fontWeight: 500 }}>
                                {rem.status || "Sent"}
                            </span>
                        </div>
                    ))}
                </div>
                <div
                    onClick={() => Notification.info("Send Reminder", "Reminder functionality is coming soon.")}
                    style={{
                        width: "100%",
                        height: fluid(48),
                        borderRadius: fluid(12),
                        backgroundColor: "#594099",
                        color: "#FFFFFF",
                        fontFamily: "Roboto, sans-serif",
                        fontSize: fluid(15),
                        fontWeight: 600,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        marginTop: fluid(8),
                        letterSpacing: "0.5px"
                    }}
                >
                    SEND NEW REMINDER
                </div>
            </div>

            {/* Card 3: Discounts */}
            <div style={{ width: "100%", backgroundColor: "#FFFFFF", borderRadius: fluid(24), padding: fluid(24), boxSizing: "border-box", display: "flex", flexDirection: "column", gap: fluid(16) }}>
                <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(20), fontWeight: 500, color: "#191919" }}>
                    Discounts
                </span>
                {discountsList.length > 0 ? (
                    discountsList.map((d, dIdx) => (
                        <div key={dIdx} style={{ width: "100%", backgroundColor: "#F8F8F8", borderRadius: fluid(16), padding: fluid(16), boxSizing: "border-box", display: "flex", gap: fluid(16), alignItems: "center" }}>
                            <div style={{ width: fluid(45), height: fluid(45), borderRadius: fluid(12), backgroundColor: "#DCF2B7", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                <img src={DiscountIcon} alt="" style={{ width: fluid(24), height: fluid(24) }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", minWidth: 0, flex: 1 }}>
                                <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(16), color: "#1A1A1A", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {d.name || "Early bird — 10%"}
                                </span>
                                <span style={{ fontFamily: "Roboto, sans-serif", fontSize: fluid(15), color: "#666666", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    &minus;₹{Number(d.amount || 0).toLocaleString()} applied
                                </span>
                            </div>
                        </div>
                    ))
                ) : (
                    <div style={{ padding: fluid(16), backgroundColor: "#F8F8F8", borderRadius: fluid(16), color: "#888888", fontSize: fluid(15), fontFamily: "Roboto, sans-serif" }}>
                        No discounts applied.
                    </div>
                )}
            </div>
        </div>
    );
};

export default FeePaymentSidebar;
